export default __webpack_public_path__ + "static/media/391.07c42af8.jpg";